// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/protosql/v1/sql_service.proto (package chalk.protosql.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { ChalkError } from "../../common/v1/chalk_error_pb";
import { file_chalk_common_v1_chalk_error } from "../../common/v1/chalk_error_pb";
import type { ColumnProfile, ColumnProfileOptions } from "../../common/v1/column_profile_pb";
import { file_chalk_common_v1_column_profile } from "../../common/v1/column_profile_pb";
import type { ResourceRequests } from "../../common/v1/resources_pb";
import { file_chalk_common_v1_resources } from "../../common/v1/resources_pb";
import type { Table } from "../../common/v2/table_pb";
import { file_chalk_common_v2_table } from "../../common/v2/table_pb";
import type { Timestamp, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/protosql/v1/sql_service.proto.
 */
export const file_chalk_protosql_v1_sql_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_auth_v1_permissions, file_chalk_common_v1_chalk_error, file_chalk_common_v1_column_profile, file_chalk_common_v1_resources, file_chalk_common_v2_table, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * Abridged version of chalk.server.v1.SqlQuery. Should think about creating a shared status between the two objects,
 * as the server one is currently int32 where 0=failure and 1=success which seems less than ideal
 *
 * @generated from message chalk.protosql.v1.SqlQueryInfo
 */
export type SqlQueryInfo = Message<"chalk.protosql.v1.SqlQueryInfo"> & {
  /**
   * @generated from field: string operation_id = 1;
   */
  operationId: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp finished_at = 3;
   */
  finishedAt?: Timestamp;
};

/**
 * Describes the message chalk.protosql.v1.SqlQueryInfo.
 * Use `create(SqlQueryInfoSchema)` to create a new message.
 */
export const SqlQueryInfoSchema: GenMessage<SqlQueryInfo> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 0);

/**
 * @generated from message chalk.protosql.v1.ExecuteSqlSyncQueryRequestOptions
 */
export type ExecuteSqlSyncQueryRequestOptions = Message<"chalk.protosql.v1.ExecuteSqlSyncQueryRequestOptions"> & {
  /**
   * @generated from field: optional string resource_group = 1;
   */
  resourceGroup?: string;
};

/**
 * Describes the message chalk.protosql.v1.ExecuteSqlSyncQueryRequestOptions.
 * Use `create(ExecuteSqlSyncQueryRequestOptionsSchema)` to create a new message.
 */
export const ExecuteSqlSyncQueryRequestOptionsSchema: GenMessage<ExecuteSqlSyncQueryRequestOptions> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 1);

/**
 * @generated from message chalk.protosql.v1.ExecuteSqlAsyncQueryRequestOptions
 */
export type ExecuteSqlAsyncQueryRequestOptions = Message<"chalk.protosql.v1.ExecuteSqlAsyncQueryRequestOptions"> & {
  /**
   * @generated from field: chalk.protosql.v1.ExecuteSqlAsyncExecutionMode execution_mode = 1;
   */
  executionMode: ExecuteSqlAsyncExecutionMode;

  /**
   * Deprecated: use resources.resource_group instead.
   *
   * @generated from field: optional string resource_group = 2 [deprecated = true];
   * @deprecated
   */
  resourceGroup?: string;

  /**
   * Environment variable overrides for the job running this query.
   *
   * @generated from field: map<string, string> env_overrides = 3;
   */
  envOverrides: { [key: string]: string };

  /**
   * Resource (cpu/memory/storage) requests for the job running this query.
   *
   * @generated from field: optional chalk.common.v1.ResourceRequests resources = 4;
   */
  resources?: ResourceRequests;

  /**
   * Whether to enable engine profiling for this query's deployment context.
   *
   * @generated from field: optional bool enable_profiling = 5;
   */
  enableProfiling?: boolean;

  /**
   * Run against a specific branch deployment instead of mainline.
   *
   * @generated from field: optional string branch = 6;
   */
  branch?: string;
};

/**
 * Describes the message chalk.protosql.v1.ExecuteSqlAsyncQueryRequestOptions.
 * Use `create(ExecuteSqlAsyncQueryRequestOptionsSchema)` to create a new message.
 */
export const ExecuteSqlAsyncQueryRequestOptionsSchema: GenMessage<ExecuteSqlAsyncQueryRequestOptions> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 2);

/**
 * @generated from message chalk.protosql.v1.ExecuteSqlResultPersistenceSettings
 */
export type ExecuteSqlResultPersistenceSettings = Message<"chalk.protosql.v1.ExecuteSqlResultPersistenceSettings"> & {
  /**
   * Whether to persist results to storage instead of returning inline
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;
};

/**
 * Describes the message chalk.protosql.v1.ExecuteSqlResultPersistenceSettings.
 * Use `create(ExecuteSqlResultPersistenceSettingsSchema)` to create a new message.
 */
export const ExecuteSqlResultPersistenceSettingsSchema: GenMessage<ExecuteSqlResultPersistenceSettings> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 3);

/**
 * @generated from message chalk.protosql.v1.GetOfflineQueryInputsRequest
 * @deprecated
 */
export type GetOfflineQueryInputsRequest = Message<"chalk.protosql.v1.GetOfflineQueryInputsRequest"> & {
  /**
   * @generated from oneof chalk.protosql.v1.GetOfflineQueryInputsRequest.identifier
   * @deprecated
   */
  identifier: {
    /**
     * @generated from field: string revision_id = 1;
     */
    value: string;
    case: "revisionId";
  } | {
    /**
     * @generated from field: string offline_query_id = 2;
     */
    value: string;
    case: "offlineQueryId";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional string resource_group = 3;
   */
  resourceGroup?: string;
};

/**
 * Describes the message chalk.protosql.v1.GetOfflineQueryInputsRequest.
 * Use `create(GetOfflineQueryInputsRequestSchema)` to create a new message.
 * @deprecated
 */
export const GetOfflineQueryInputsRequestSchema: GenMessage<GetOfflineQueryInputsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 4);

/**
 * @generated from message chalk.protosql.v1.GetOfflineQueryInputsResponse
 * @deprecated
 */
export type GetOfflineQueryInputsResponse = Message<"chalk.protosql.v1.GetOfflineQueryInputsResponse"> & {
  /**
   * @generated from field: chalk.protosql.v1.ExecuteSqlQueryResponse response = 1;
   */
  response?: ExecuteSqlQueryResponse;

  /**
   * @generated from field: string generated_query = 2;
   */
  generatedQuery: string;
};

/**
 * Describes the message chalk.protosql.v1.GetOfflineQueryInputsResponse.
 * Use `create(GetOfflineQueryInputsResponseSchema)` to create a new message.
 * @deprecated
 */
export const GetOfflineQueryInputsResponseSchema: GenMessage<GetOfflineQueryInputsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 5);

/**
 * @generated from message chalk.protosql.v1.GetOfflineQueryPreviewRequest
 * @deprecated
 */
export type GetOfflineQueryPreviewRequest = Message<"chalk.protosql.v1.GetOfflineQueryPreviewRequest"> & {
  /**
   * @generated from oneof chalk.protosql.v1.GetOfflineQueryPreviewRequest.identifier
   * @deprecated
   */
  identifier: {
    /**
     * @generated from field: string revision_id = 1;
     */
    value: string;
    case: "revisionId";
  } | {
    /**
     * @generated from field: string offline_query_id = 2;
     */
    value: string;
    case: "offlineQueryId";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional string resource_group = 3;
   */
  resourceGroup?: string;
};

/**
 * Describes the message chalk.protosql.v1.GetOfflineQueryPreviewRequest.
 * Use `create(GetOfflineQueryPreviewRequestSchema)` to create a new message.
 * @deprecated
 */
export const GetOfflineQueryPreviewRequestSchema: GenMessage<GetOfflineQueryPreviewRequest> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 6);

/**
 * @generated from message chalk.protosql.v1.GetOfflineQueryPreviewResponse
 * @deprecated
 */
export type GetOfflineQueryPreviewResponse = Message<"chalk.protosql.v1.GetOfflineQueryPreviewResponse"> & {
  /**
   * @generated from field: chalk.protosql.v1.ExecuteSqlQueryResponse response = 1;
   */
  response?: ExecuteSqlQueryResponse;

  /**
   * @generated from field: string generated_query = 2;
   */
  generatedQuery: string;
};

/**
 * Describes the message chalk.protosql.v1.GetOfflineQueryPreviewResponse.
 * Use `create(GetOfflineQueryPreviewResponseSchema)` to create a new message.
 * @deprecated
 */
export const GetOfflineQueryPreviewResponseSchema: GenMessage<GetOfflineQueryPreviewResponse> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 7);

/**
 * @generated from message chalk.protosql.v1.GetOfflineQueryStatsRequest
 * @deprecated
 */
export type GetOfflineQueryStatsRequest = Message<"chalk.protosql.v1.GetOfflineQueryStatsRequest"> & {
  /**
   * @generated from oneof chalk.protosql.v1.GetOfflineQueryStatsRequest.identifier
   * @deprecated
   */
  identifier: {
    /**
     * @generated from field: string revision_id = 1;
     */
    value: string;
    case: "revisionId";
  } | {
    /**
     * @generated from field: string offline_query_id = 2;
     */
    value: string;
    case: "offlineQueryId";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional string resource_group = 3;
   */
  resourceGroup?: string;
};

/**
 * Describes the message chalk.protosql.v1.GetOfflineQueryStatsRequest.
 * Use `create(GetOfflineQueryStatsRequestSchema)` to create a new message.
 * @deprecated
 */
export const GetOfflineQueryStatsRequestSchema: GenMessage<GetOfflineQueryStatsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 8);

/**
 * @generated from message chalk.protosql.v1.GetOfflineQueryStatsResponse
 * @deprecated
 */
export type GetOfflineQueryStatsResponse = Message<"chalk.protosql.v1.GetOfflineQueryStatsResponse"> & {
  /**
   * @generated from field: chalk.protosql.v1.ExecuteSqlQueryResponse response = 1;
   */
  response?: ExecuteSqlQueryResponse;

  /**
   * @generated from field: string generated_query = 2;
   */
  generatedQuery: string;
};

/**
 * Describes the message chalk.protosql.v1.GetOfflineQueryStatsResponse.
 * Use `create(GetOfflineQueryStatsResponseSchema)` to create a new message.
 * @deprecated
 */
export const GetOfflineQueryStatsResponseSchema: GenMessage<GetOfflineQueryStatsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 9);

/**
 * @generated from message chalk.protosql.v1.ExecuteSqlQueryRequest
 */
export type ExecuteSqlQueryRequest = Message<"chalk.protosql.v1.ExecuteSqlQueryRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: optional string correlation_id = 2;
   */
  correlationId?: string;

  /**
   * @generated from field: chalk.protosql.v1.ExecuteSqlResultPersistenceSettings persistence_settings = 3;
   */
  persistenceSettings?: ExecuteSqlResultPersistenceSettings;

  /**
   * Maximum number of bytes of memory to allow for query execution
   *
   * @generated from field: optional int64 max_memory_bytes = 4;
   */
  maxMemoryBytes?: bigint;

  /**
   * Optional datasource name. When set, the query is executed against that datasource.
   *
   * @generated from field: optional string datasource_name = 5;
   */
  datasourceName?: string;

  /**
   * Presence of one of these options will allow go-api-server grpc engine proxy to do the right thing here.
   * Older clients will not specify any of these, which will default us to running ChalkSQL synchronously.
   *
   * @generated from oneof chalk.protosql.v1.ExecuteSqlQueryRequest.options
   */
  options: {
    /**
     * @generated from field: chalk.protosql.v1.ExecuteSqlSyncQueryRequestOptions sync_options = 10;
     */
    value: ExecuteSqlSyncQueryRequestOptions;
    case: "syncOptions";
  } | {
    /**
     * @generated from field: chalk.protosql.v1.ExecuteSqlAsyncQueryRequestOptions async_options = 11;
     */
    value: ExecuteSqlAsyncQueryRequestOptions;
    case: "asyncOptions";
  } | { case: undefined; value?: undefined };

  /**
   * Compilation options as key-value pairs. Keys correspond to fields of CompilationOptions.
   *
   * @generated from field: map<string, google.protobuf.Value> compilation_options = 12;
   */
  compilationOptions: { [key: string]: Value };

  /**
   * Opt-in per-column distribution profiles over the query result. Off unless
   * set: profiling runs an extra aggregation over the result, so callers that
   * do not render distributions should not pay for it.
   *
   * @generated from field: chalk.common.v1.ColumnProfileOptions column_profile_options = 13;
   */
  columnProfileOptions?: ColumnProfileOptions;

  /**
   * Caller-supplied tables the query can read by name, as in `SELECT * FROM my_table`. Each
   * is scanned as a named-table input to the plan, like DataFrameService.ExecutePlan's
   * `tables`. A name shadows a catalog table of the same name, and a CTE shadows both.
   * Only inline `feather` payloads are accepted, and only for sync execution.
   *
   * @generated from field: map<string, chalk.common.v2.Table> tables = 14;
   */
  tables: { [key: string]: Table };

  /**
   * Query-history annotations. Chalk-owned keys use the chalk. prefix, including chalk.origin.
   * Values do not control query execution.
   *
   * @generated from field: map<string, string> metadata = 15;
   */
  metadata: { [key: string]: string };
};

/**
 * Describes the message chalk.protosql.v1.ExecuteSqlQueryRequest.
 * Use `create(ExecuteSqlQueryRequestSchema)` to create a new message.
 */
export const ExecuteSqlQueryRequestSchema: GenMessage<ExecuteSqlQueryRequest> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 10);

/**
 * @generated from message chalk.protosql.v1.SignedOutputUris
 */
export type SignedOutputUris = Message<"chalk.protosql.v1.SignedOutputUris"> & {
  /**
   * Signed URLs for downloading query results from cloud storage (expires in 10 minutes)
   *
   * @generated from field: repeated string uris = 1;
   */
  uris: string[];
};

/**
 * Describes the message chalk.protosql.v1.SignedOutputUris.
 * Use `create(SignedOutputUrisSchema)` to create a new message.
 */
export const SignedOutputUrisSchema: GenMessage<SignedOutputUris> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 11);

/**
 * @generated from message chalk.protosql.v1.ExecuteSqlSyncQueryResponsePayload
 */
export type ExecuteSqlSyncQueryResponsePayload = Message<"chalk.protosql.v1.ExecuteSqlSyncQueryResponsePayload"> & {
  /**
   * @generated from oneof chalk.protosql.v1.ExecuteSqlSyncQueryResponsePayload.payload
   */
  payload: {
    /**
     * @generated from field: bytes parquet_response = 1;
     */
    value: Uint8Array;
    case: "parquetResponse";
  } | {
    /**
     * @generated from field: chalk.protosql.v1.SignedOutputUris signed_output_uris = 10;
     */
    value: SignedOutputUris;
    case: "signedOutputUris";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.protosql.v1.ExecuteSqlSyncQueryResponsePayload.
 * Use `create(ExecuteSqlSyncQueryResponsePayloadSchema)` to create a new message.
 */
export const ExecuteSqlSyncQueryResponsePayloadSchema: GenMessage<ExecuteSqlSyncQueryResponsePayload> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 12);

/**
 * @generated from message chalk.protosql.v1.ExecuteSqlAsyncQueryResponsePayload
 */
export type ExecuteSqlAsyncQueryResponsePayload = Message<"chalk.protosql.v1.ExecuteSqlAsyncQueryResponsePayload"> & {
  /**
   * TODO: Use the shared SqlQuery object
   *
   * @generated from field: string operation_id = 1;
   */
  operationId: string;

  /**
   * @generated from field: chalk.protosql.v1.ExecuteSqlAsyncExecutionMode execution_mode = 2;
   */
  executionMode: ExecuteSqlAsyncExecutionMode;
};

/**
 * Describes the message chalk.protosql.v1.ExecuteSqlAsyncQueryResponsePayload.
 * Use `create(ExecuteSqlAsyncQueryResponsePayloadSchema)` to create a new message.
 */
export const ExecuteSqlAsyncQueryResponsePayloadSchema: GenMessage<ExecuteSqlAsyncQueryResponsePayload> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 13);

/**
 * @generated from message chalk.protosql.v1.ExecuteSqlQueryResponse
 */
export type ExecuteSqlQueryResponse = Message<"chalk.protosql.v1.ExecuteSqlQueryResponse"> & {
  /**
   * TODO: Use the shared SqlQuery object
   *
   * @generated from field: string query_id = 1;
   */
  queryId: string;

  /**
   * @generated from oneof chalk.protosql.v1.ExecuteSqlQueryResponse.payload
   */
  payload: {
    /**
     * TODO: deprecate
     *
     * @generated from field: bytes parquet = 2;
     */
    value: Uint8Array;
    case: "parquet";
  } | {
    /**
     * @generated from field: chalk.protosql.v1.ExecuteSqlSyncQueryResponsePayload sync_payload = 10;
     */
    value: ExecuteSqlSyncQueryResponsePayload;
    case: "syncPayload";
  } | {
    /**
     * @generated from field: chalk.protosql.v1.ExecuteSqlAsyncQueryResponsePayload async_payload = 11;
     */
    value: ExecuteSqlAsyncQueryResponsePayload;
    case: "asyncPayload";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: repeated chalk.common.v1.ChalkError errors = 3;
   */
  errors: ChalkError[];

  /**
   * JSON-encoded performance summary, populated for sync queries when
   * compilation_options includes generate_performance_summary=true.
   *
   * @generated from field: optional string performance_summary = 4;
   */
  performanceSummary?: string;

  /**
   * Populated only when column_profile_options.enabled was set, and only for
   * sync execution (async results are not held in memory here). One entry per
   * result column, in result-schema order. A column whose kind has no producer
   * yet still gets an entry, carrying its filled/empty counts and no bins.
   *
   * @generated from field: repeated chalk.common.v1.ColumnProfile column_profiles = 5;
   */
  columnProfiles: ColumnProfile[];
};

/**
 * Describes the message chalk.protosql.v1.ExecuteSqlQueryResponse.
 * Use `create(ExecuteSqlQueryResponseSchema)` to create a new message.
 */
export const ExecuteSqlQueryResponseSchema: GenMessage<ExecuteSqlQueryResponse> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 14);

/**
 * @generated from message chalk.protosql.v1.ExecuteSqlQueryStreamRequest
 */
export type ExecuteSqlQueryStreamRequest = Message<"chalk.protosql.v1.ExecuteSqlQueryStreamRequest"> & {
  /**
   * The query to run, in exactly the form ExecuteSqlQuery takes it. Carried rather than
   * restated so the two endpoints cannot drift apart on what a request means; the streaming
   * endpoint only narrows which of its options are accepted.
   *
   * @generated from field: chalk.protosql.v1.ExecuteSqlQueryRequest request = 1;
   */
  request?: ExecuteSqlQueryRequest;
};

/**
 * Describes the message chalk.protosql.v1.ExecuteSqlQueryStreamRequest.
 * Use `create(ExecuteSqlQueryStreamRequestSchema)` to create a new message.
 */
export const ExecuteSqlQueryStreamRequestSchema: GenMessage<ExecuteSqlQueryStreamRequest> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 15);

/**
 * One message of a streaming ChalkSQL execution. Exactly one `payload` is set, and the
 * sequence for a successful query is: one `started`, zero or more `chunk`s, one `completed`.
 * A stream that ends without a `completed` message failed; the gRPC status carries why.
 *
 * @generated from message chalk.protosql.v1.ExecuteSqlQueryStreamResponse
 */
export type ExecuteSqlQueryStreamResponse = Message<"chalk.protosql.v1.ExecuteSqlQueryStreamResponse"> & {
  /**
   * Identifies the query in the dashboard and in `sql_queries`. Set on every message of the
   * stream, so a client that only keeps the latest message still has it.
   *
   * @generated from field: string query_id = 1;
   */
  queryId: string;

  /**
   * @generated from oneof chalk.protosql.v1.ExecuteSqlQueryStreamResponse.payload
   */
  payload: {
    /**
     * @generated from field: chalk.protosql.v1.SqlQueryStreamStarted started = 10;
     */
    value: SqlQueryStreamStarted;
    case: "started";
  } | {
    /**
     * @generated from field: chalk.protosql.v1.SqlQueryResultChunk chunk = 11;
     */
    value: SqlQueryResultChunk;
    case: "chunk";
  } | {
    /**
     * @generated from field: chalk.protosql.v1.SqlQueryStreamCompleted completed = 12;
     */
    value: SqlQueryStreamCompleted;
    case: "completed";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.protosql.v1.ExecuteSqlQueryStreamResponse.
 * Use `create(ExecuteSqlQueryStreamResponseSchema)` to create a new message.
 */
export const ExecuteSqlQueryStreamResponseSchema: GenMessage<ExecuteSqlQueryStreamResponse> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 16);

/**
 * Sent once, as soon as the plan is compiled and running -- before any rows exist. Lets a
 * client render the result's columns while the first chunk is still being computed.
 *
 * @generated from message chalk.protosql.v1.SqlQueryStreamStarted
 */
export type SqlQueryStreamStarted = Message<"chalk.protosql.v1.SqlQueryStreamStarted"> & {
  /**
   * The result schema, serialized as an Arrow IPC schema message.
   *
   * @generated from field: bytes arrow_schema = 1;
   */
  arrowSchema: Uint8Array;
};

/**
 * Describes the message chalk.protosql.v1.SqlQueryStreamStarted.
 * Use `create(SqlQueryStreamStartedSchema)` to create a new message.
 */
export const SqlQueryStreamStartedSchema: GenMessage<SqlQueryStreamStarted> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 17);

/**
 * A prefix of the result, sent as soon as the plan produces it.
 *
 * @generated from message chalk.protosql.v1.SqlQueryResultChunk
 */
export type SqlQueryResultChunk = Message<"chalk.protosql.v1.SqlQueryResultChunk"> & {
  /**
   * The chunk's rows as a self-contained, snappy-compressed Parquet file. Every chunk carries
   * the full result schema, so a chunk can be decoded on its own and chunks can be
   * concatenated in arrival order.
   *
   * @generated from field: bytes parquet = 1;
   */
  parquet: Uint8Array;

  /**
   * Position of this chunk in the stream, starting at 0. Chunks arrive in plan order.
   *
   * @generated from field: int64 chunk_index = 2;
   */
  chunkIndex: bigint;

  /**
   * @generated from field: int64 num_rows = 3;
   */
  numRows: bigint;
};

/**
 * Describes the message chalk.protosql.v1.SqlQueryResultChunk.
 * Use `create(SqlQueryResultChunkSchema)` to create a new message.
 */
export const SqlQueryResultChunkSchema: GenMessage<SqlQueryResultChunk> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 18);

/**
 * Sent once, after the last chunk, carrying what is only known once the query has finished.
 *
 * @generated from message chalk.protosql.v1.SqlQueryStreamCompleted
 */
export type SqlQueryStreamCompleted = Message<"chalk.protosql.v1.SqlQueryStreamCompleted"> & {
  /**
   * Errors encountered during execution. A query that reports errors here may still have
   * emitted chunks; those rows are whatever the plan produced before it gave up.
   *
   * @generated from field: repeated chalk.common.v1.ChalkError errors = 1;
   */
  errors: ChalkError[];

  /**
   * JSON-encoded performance summary, populated when compilation_options includes
   * generate_performance_summary=true.
   *
   * @generated from field: optional string performance_summary = 2;
   */
  performanceSummary?: string;

  /**
   * @generated from field: int64 total_rows = 3;
   */
  totalRows: bigint;
};

/**
 * Describes the message chalk.protosql.v1.SqlQueryStreamCompleted.
 * Use `create(SqlQueryStreamCompletedSchema)` to create a new message.
 */
export const SqlQueryStreamCompletedSchema: GenMessage<SqlQueryStreamCompleted> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 19);

/**
 * @generated from message chalk.protosql.v1.PlanSqlQueryRequest
 */
export type PlanSqlQueryRequest = Message<"chalk.protosql.v1.PlanSqlQueryRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;
};

/**
 * Describes the message chalk.protosql.v1.PlanSqlQueryRequest.
 * Use `create(PlanSqlQueryRequestSchema)` to create a new message.
 */
export const PlanSqlQueryRequestSchema: GenMessage<PlanSqlQueryRequest> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 20);

/**
 * @generated from message chalk.protosql.v1.PlanSqlQueryResponse
 */
export type PlanSqlQueryResponse = Message<"chalk.protosql.v1.PlanSqlQueryResponse"> & {
  /**
   * @generated from field: string logical_plan = 1;
   */
  logicalPlan: string;

  /**
   * @generated from field: repeated chalk.common.v1.ChalkError errors = 5;
   */
  errors: ChalkError[];
};

/**
 * Describes the message chalk.protosql.v1.PlanSqlQueryResponse.
 * Use `create(PlanSqlQueryResponseSchema)` to create a new message.
 */
export const PlanSqlQueryResponseSchema: GenMessage<PlanSqlQueryResponse> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 21);

/**
 * @generated from message chalk.protosql.v1.GetDbCatalogsRequest
 */
export type GetDbCatalogsRequest = Message<"chalk.protosql.v1.GetDbCatalogsRequest"> & {
};

/**
 * Describes the message chalk.protosql.v1.GetDbCatalogsRequest.
 * Use `create(GetDbCatalogsRequestSchema)` to create a new message.
 */
export const GetDbCatalogsRequestSchema: GenMessage<GetDbCatalogsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 22);

/**
 * @generated from message chalk.protosql.v1.DbCatalogInfo
 */
export type DbCatalogInfo = Message<"chalk.protosql.v1.DbCatalogInfo"> & {
  /**
   * @generated from field: string catalog_name = 1;
   */
  catalogName: string;

  /**
   * @generated from field: string catalog_type = 2;
   */
  catalogType: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: optional string backend = 4;
   */
  backend?: string;

  /**
   * Whether datasource_query(catalog_name, query) supports this catalog.
   *
   * @generated from field: bool supports_datasource_query = 5;
   */
  supportsDatasourceQuery: boolean;
};

/**
 * Describes the message chalk.protosql.v1.DbCatalogInfo.
 * Use `create(DbCatalogInfoSchema)` to create a new message.
 */
export const DbCatalogInfoSchema: GenMessage<DbCatalogInfo> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 23);

/**
 * @generated from message chalk.protosql.v1.GetDbCatalogsResponse
 */
export type GetDbCatalogsResponse = Message<"chalk.protosql.v1.GetDbCatalogsResponse"> & {
  /**
   * @generated from field: repeated string catalog_names = 1;
   */
  catalogNames: string[];

  /**
   * Per-catalog metadata, parallel to catalog_names. Clients that filter on
   * supports_datasource_query must tolerate this being empty on older engines.
   *
   * @generated from field: repeated chalk.protosql.v1.DbCatalogInfo catalogs = 2;
   */
  catalogs: DbCatalogInfo[];

  /**
   * @generated from field: repeated chalk.common.v1.ChalkError errors = 5;
   */
  errors: ChalkError[];
};

/**
 * Describes the message chalk.protosql.v1.GetDbCatalogsResponse.
 * Use `create(GetDbCatalogsResponseSchema)` to create a new message.
 */
export const GetDbCatalogsResponseSchema: GenMessage<GetDbCatalogsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 24);

/**
 * @generated from message chalk.protosql.v1.GetDbSchemasRequest
 */
export type GetDbSchemasRequest = Message<"chalk.protosql.v1.GetDbSchemasRequest"> & {
  /**
   * @generated from field: optional string catalog = 1;
   */
  catalog?: string;

  /**
   * @generated from field: optional string db_schema_filter_pattern = 2;
   */
  dbSchemaFilterPattern?: string;

  /**
   * @generated from field: repeated chalk.common.v1.ChalkError errors = 5;
   */
  errors: ChalkError[];
};

/**
 * Describes the message chalk.protosql.v1.GetDbSchemasRequest.
 * Use `create(GetDbSchemasRequestSchema)` to create a new message.
 */
export const GetDbSchemasRequestSchema: GenMessage<GetDbSchemasRequest> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 25);

/**
 * @generated from message chalk.protosql.v1.DbSchemaInfo
 */
export type DbSchemaInfo = Message<"chalk.protosql.v1.DbSchemaInfo"> & {
  /**
   * @generated from field: string catalog_name = 1;
   */
  catalogName: string;

  /**
   * @generated from field: string db_schema_name = 2;
   */
  dbSchemaName: string;
};

/**
 * Describes the message chalk.protosql.v1.DbSchemaInfo.
 * Use `create(DbSchemaInfoSchema)` to create a new message.
 */
export const DbSchemaInfoSchema: GenMessage<DbSchemaInfo> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 26);

/**
 * @generated from message chalk.protosql.v1.GetDbSchemasResponse
 */
export type GetDbSchemasResponse = Message<"chalk.protosql.v1.GetDbSchemasResponse"> & {
  /**
   * @generated from field: repeated chalk.protosql.v1.DbSchemaInfo schemas = 1;
   */
  schemas: DbSchemaInfo[];

  /**
   * @generated from field: repeated chalk.common.v1.ChalkError errors = 5;
   */
  errors: ChalkError[];
};

/**
 * Describes the message chalk.protosql.v1.GetDbSchemasResponse.
 * Use `create(GetDbSchemasResponseSchema)` to create a new message.
 */
export const GetDbSchemasResponseSchema: GenMessage<GetDbSchemasResponse> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 27);

/**
 * @generated from message chalk.protosql.v1.GetTablesRequest
 */
export type GetTablesRequest = Message<"chalk.protosql.v1.GetTablesRequest"> & {
  /**
   * @generated from field: optional string catalog = 1;
   */
  catalog?: string;

  /**
   * @generated from field: optional string db_schema_filter_pattern = 2;
   */
  dbSchemaFilterPattern?: string;

  /**
   * @generated from field: optional string table_name_filter_pattern = 3;
   */
  tableNameFilterPattern?: string;

  /**
   * @generated from field: bool include_schemas = 10;
   */
  includeSchemas: boolean;
};

/**
 * Describes the message chalk.protosql.v1.GetTablesRequest.
 * Use `create(GetTablesRequestSchema)` to create a new message.
 */
export const GetTablesRequestSchema: GenMessage<GetTablesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 28);

/**
 * @generated from message chalk.protosql.v1.TableInfo
 */
export type TableInfo = Message<"chalk.protosql.v1.TableInfo"> & {
  /**
   * @generated from field: string catalog_name = 1;
   */
  catalogName: string;

  /**
   * @generated from field: string db_schema_name = 2;
   */
  dbSchemaName: string;

  /**
   * @generated from field: string table_name = 3;
   */
  tableName: string;

  /**
   * Serialized arrow schema
   *
   * @generated from field: optional bytes table_arrow_schema = 4;
   */
  tableArrowSchema?: Uint8Array;
};

/**
 * Describes the message chalk.protosql.v1.TableInfo.
 * Use `create(TableInfoSchema)` to create a new message.
 */
export const TableInfoSchema: GenMessage<TableInfo> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 29);

/**
 * @generated from message chalk.protosql.v1.GetTablesResponse
 */
export type GetTablesResponse = Message<"chalk.protosql.v1.GetTablesResponse"> & {
  /**
   * @generated from field: repeated chalk.protosql.v1.TableInfo tables = 1;
   */
  tables: TableInfo[];

  /**
   * @generated from field: repeated chalk.common.v1.ChalkError errors = 5;
   */
  errors: ChalkError[];
};

/**
 * Describes the message chalk.protosql.v1.GetTablesResponse.
 * Use `create(GetTablesResponseSchema)` to create a new message.
 */
export const GetTablesResponseSchema: GenMessage<GetTablesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 30);

/**
 * Progress information for a running SQL query
 *
 * TODO: Eventually we will want rows/bytes processed here when we have better introspection into these metrics.
 * TODO: Things like a percent estimate on how far along we are would be good, but there's no useful way for
 * TODO: us to measure this right now so leaving it empty
 *
 * @generated from message chalk.protosql.v1.SqlQueryProgressInfo
 */
export type SqlQueryProgressInfo = Message<"chalk.protosql.v1.SqlQueryProgressInfo"> & {
};

/**
 * Describes the message chalk.protosql.v1.SqlQueryProgressInfo.
 * Use `create(SqlQueryProgressInfoSchema)` to create a new message.
 */
export const SqlQueryProgressInfoSchema: GenMessage<SqlQueryProgressInfo> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 31);

/**
 * @generated from message chalk.protosql.v1.SqlQueryFailedInfo
 */
export type SqlQueryFailedInfo = Message<"chalk.protosql.v1.SqlQueryFailedInfo"> & {
  /**
   * Errors encountered during query execution, if any
   *
   * @generated from field: repeated chalk.common.v1.ChalkError errors = 1;
   */
  errors: ChalkError[];
};

/**
 * Describes the message chalk.protosql.v1.SqlQueryFailedInfo.
 * Use `create(SqlQueryFailedInfoSchema)` to create a new message.
 */
export const SqlQueryFailedInfoSchema: GenMessage<SqlQueryFailedInfo> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 32);

/**
 * Request to poll for the status and results of an asynchronous SQL query
 *
 * @generated from message chalk.protosql.v1.PollSqlQueryRequest
 */
export type PollSqlQueryRequest = Message<"chalk.protosql.v1.PollSqlQueryRequest"> & {
  /**
   * The operation ID returned from ExecuteSqlQueryResponse.async_payload
   *
   * @generated from field: string operation_id = 1;
   */
  operationId: string;

  /**
   * Opt-in per-column distribution profiles over a successful persisted
   * result. Off unless set so polling clients that do not render
   * distributions do not pay to read and profile the output files.
   *
   * @generated from field: chalk.common.v1.ColumnProfileOptions column_profile_options = 2;
   */
  columnProfileOptions?: ColumnProfileOptions;
};

/**
 * Describes the message chalk.protosql.v1.PollSqlQueryRequest.
 * Use `create(PollSqlQueryRequestSchema)` to create a new message.
 */
export const PollSqlQueryRequestSchema: GenMessage<PollSqlQueryRequest> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 33);

/**
 * Response containing the status and results of an asynchronous SQL query
 *
 * @generated from message chalk.protosql.v1.PollSqlQueryResponse
 */
export type PollSqlQueryResponse = Message<"chalk.protosql.v1.PollSqlQueryResponse"> & {
  /**
   * @generated from field: chalk.protosql.v1.SqlQueryInfo info = 1;
   */
  info?: SqlQueryInfo;

  /**
   * @generated from oneof chalk.protosql.v1.PollSqlQueryResponse.result
   */
  result: {
    /**
     * Progress information if the query is still running
     *
     * @generated from field: chalk.protosql.v1.SqlQueryProgressInfo progress = 10;
     */
    value: SqlQueryProgressInfo;
    case: "progress";
  } | {
    /**
     * Query results if query was successful
     *
     * @generated from field: chalk.protosql.v1.ExecuteSqlSyncQueryResponsePayload response = 11;
     */
    value: ExecuteSqlSyncQueryResponsePayload;
    case: "response";
  } | {
    /**
     * Info regarding failure if query failed
     *
     * @generated from field: chalk.protosql.v1.SqlQueryFailedInfo failed = 12;
     */
    value: SqlQueryFailedInfo;
    case: "failed";
  } | { case: undefined; value?: undefined };

  /**
   * URI of the performance summary file in cloud storage, populated while the
   * query is running (status=progress) when compilation_options includes
   * update_performance_summary_interval_seconds. Poll this URI to get live
   * query progress. Signed by the engine; valid for 15 minutes.
   *
   * @generated from field: optional string performance_summary_uri = 13;
   */
  performanceSummaryUri?: string;

  /**
   * Populated on a successful response only when
   * column_profile_options.enabled was set. Profiles cover all persisted
   * result shards as one logical result.
   *
   * @generated from field: repeated chalk.common.v1.ColumnProfile column_profiles = 14;
   */
  columnProfiles: ColumnProfile[];
};

/**
 * Describes the message chalk.protosql.v1.PollSqlQueryResponse.
 * Use `create(PollSqlQueryResponseSchema)` to create a new message.
 */
export const PollSqlQueryResponseSchema: GenMessage<PollSqlQueryResponse> = /*@__PURE__*/
  messageDesc(file_chalk_protosql_v1_sql_service, 34);

/**
 * @generated from enum chalk.protosql.v1.ExecuteSqlAsyncExecutionMode
 */
export enum ExecuteSqlAsyncExecutionMode {
  /**
   * @generated from enum value: EXECUTE_SQL_ASYNC_EXECUTION_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Run similarly to offline query without async, where you still poll for results but it runs in process.
   *
   * @generated from enum value: EXECUTE_SQL_ASYNC_EXECUTION_MODE_IN_PROCESS = 1;
   */
  IN_PROCESS = 1,

  /**
   * Run similarly to offline query async
   *
   * @generated from enum value: EXECUTE_SQL_ASYNC_EXECUTION_MODE_ASYNC = 2;
   */
  ASYNC = 2,
}

/**
 * Describes the enum chalk.protosql.v1.ExecuteSqlAsyncExecutionMode.
 */
export const ExecuteSqlAsyncExecutionModeSchema: GenEnum<ExecuteSqlAsyncExecutionMode> = /*@__PURE__*/
  enumDesc(file_chalk_protosql_v1_sql_service, 0);

/**
 * @generated from service chalk.protosql.v1.SqlService
 */
export const SqlService: GenService<{
  /**
   * Deprecated: returns UNIMPLEMENTED. Query the offline query's data with ChalkSQL
   * (ExecuteSqlQuery) and get_dataset_revision / get_dataset_givens instead.
   *
   * @generated from rpc chalk.protosql.v1.SqlService.GetOfflineQueryInputs
   * @deprecated
   */
  getOfflineQueryInputs: {
    methodKind: "unary";
    input: typeof GetOfflineQueryInputsRequestSchema;
    output: typeof GetOfflineQueryInputsResponseSchema;
  },
  /**
   * Deprecated: returns UNIMPLEMENTED; see GetOfflineQueryInputs.
   *
   * @generated from rpc chalk.protosql.v1.SqlService.GetOfflineQueryPreview
   * @deprecated
   */
  getOfflineQueryPreview: {
    methodKind: "unary";
    input: typeof GetOfflineQueryPreviewRequestSchema;
    output: typeof GetOfflineQueryPreviewResponseSchema;
  },
  /**
   * Deprecated: returns UNIMPLEMENTED; see GetOfflineQueryInputs.
   *
   * @generated from rpc chalk.protosql.v1.SqlService.GetOfflineQueryStats
   * @deprecated
   */
  getOfflineQueryStats: {
    methodKind: "unary";
    input: typeof GetOfflineQueryStatsRequestSchema;
    output: typeof GetOfflineQueryStatsResponseSchema;
  },
  /**
   * @generated from rpc chalk.protosql.v1.SqlService.ExecuteSqlQuery
   */
  executeSqlQuery: {
    methodKind: "unary";
    input: typeof ExecuteSqlQueryRequestSchema;
    output: typeof ExecuteSqlQueryResponseSchema;
  },
  /**
   * Execute a SQL query, emitting each chunk of the result as the plan produces it instead of
   * gathering the whole result first. Same request as ExecuteSqlQuery and the same execution;
   * only the delivery differs, so a query whose leading rows are cheap becomes visible while
   * its expensive tail is still running.
   *
   * Rows are streamed, never persisted, and never profiled: async_options,
   * persistence_settings.enabled and column_profile_options.enabled are each rejected, since
   * each of them replaces the plan's row output with something else (an operation id to poll,
   * a write summary, an aggregation over the whole result). Use ExecuteSqlQuery for those.
   *
   * @generated from rpc chalk.protosql.v1.SqlService.ExecuteSqlQueryStream
   */
  executeSqlQueryStream: {
    methodKind: "server_streaming";
    input: typeof ExecuteSqlQueryStreamRequestSchema;
    output: typeof ExecuteSqlQueryStreamResponseSchema;
  },
  /**
   * @generated from rpc chalk.protosql.v1.SqlService.PlanSqlQuery
   */
  planSqlQuery: {
    methodKind: "unary";
    input: typeof PlanSqlQueryRequestSchema;
    output: typeof PlanSqlQueryResponseSchema;
  },
  /**
   * Poll for the status and results of an asynchronous SQL query
   *
   * @generated from rpc chalk.protosql.v1.SqlService.PollSqlQuery
   */
  pollSqlQuery: {
    methodKind: "unary";
    input: typeof PollSqlQueryRequestSchema;
    output: typeof PollSqlQueryResponseSchema;
  },
  /**
   * @generated from rpc chalk.protosql.v1.SqlService.GetDbCatalogs
   */
  getDbCatalogs: {
    methodKind: "unary";
    input: typeof GetDbCatalogsRequestSchema;
    output: typeof GetDbCatalogsResponseSchema;
  },
  /**
   * @generated from rpc chalk.protosql.v1.SqlService.GetDbSchemas
   */
  getDbSchemas: {
    methodKind: "unary";
    input: typeof GetDbSchemasRequestSchema;
    output: typeof GetDbSchemasResponseSchema;
  },
  /**
   * @generated from rpc chalk.protosql.v1.SqlService.GetTables
   */
  getTables: {
    methodKind: "unary";
    input: typeof GetTablesRequestSchema;
    output: typeof GetTablesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_protosql_v1_sql_service, 0);

